//import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import FormSelect from "../form/FormSelect";
import { fleetDepartmentOptions } from '../../libs/common';

class FleetDepartmentPicker extends PureComponent {
	render () {
		return (
			<FormSelect
				{...this.props}
				options={fleetDepartmentOptions}
			/>
		);
	}
}

FleetDepartmentPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

FleetDepartmentPicker.defaultProps =  {
	label : 'Fleet / Department',
};

export default FleetDepartmentPicker;